import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button, Container, Message } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { EditorReportView } from './bookEditorFeedback';
import {
  sampleEditorialReport,
  SAMPLE_REPORT_BOOK_TITLE,
} from 'src/data/sampleEditorialReport';

const Wrap = styled(Container)`
  max-width: 820px !important;
  padding: 24px 16px 64px;
`;

const Banner = styled(Message)`
  display: flex !important;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

/**
 * Public, static sample of an AI Editor report (Pride and Prejudice). Served
 * from the bundle — zero marginal cost, no LLM call — so it can be shown to
 * anyone as proof of the deliverable before they run their own.
 */
const EditorReportSample: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const isAuthed = useSelector((state: any) => !!state.user?.userProfile);

  return (
    <Wrap>
      <Banner info>
        <div style={{ flex: 1, minWidth: 220 }}>
          <strong>
            {t('SampleReportBanner', 'Sample report — {{title}}', {
              title: SAMPLE_REPORT_BOOK_TITLE,
            })}
          </strong>
          <div style={{ color: 'rgba(0,0,0,0.6)' }}>
            {t(
              'SampleReportBannerSub',
              'This is a real example of the full editorial report. Yours analyses your own manuscript, in your language.'
            )}
          </div>
        </div>
        <Button
          primary
          content={t('RunItOnMyBook', 'Run it on my book')}
          onClick={() => history.push(isAuthed ? '/mymanuscripts' : '/signup')}
        />
      </Banner>

      <EditorReportView report={sampleEditorialReport} />

      <div style={{ textAlign: 'center', marginTop: 32 }}>
        <Button
          primary
          size="large"
          content={t('RunItOnMyBook', 'Run it on my book')}
          onClick={() => history.push(isAuthed ? '/mymanuscripts' : '/signup')}
        />
      </div>
    </Wrap>
  );
};

export default EditorReportSample;
